import { render, staticRenderFns } from "./ModalRemoving.vue?vue&type=template&id=3669bcfe&scoped=true&"
import script from "./ModalRemoving.vue?vue&type=script&lang=js&"
export * from "./ModalRemoving.vue?vue&type=script&lang=js&"
import style0 from "./ModalRemoving.vue?vue&type=style&index=0&id=3669bcfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3669bcfe",
  null
  
)

export default component.exports